import {
  CHART_AREA_GRADIENT_END_ALPHA,
  CHART_AREA_GRADIENT_END_STOP,
  CHART_AREA_GRADIENT_MID_ALPHA,
  CHART_AREA_GRADIENT_MID_STOP,
  CHART_AREA_GRADIENT_START_ALPHA,
  CHART_AREA_GRADIENT_START_STOP,
} from "../constants";

export const createAreaGradientFill = (color: string) => ({
  type: "gradient" as const,
  colorStops: [
    {
      color: `${color}${CHART_AREA_GRADIENT_END_ALPHA}`,
      stop: CHART_AREA_GRADIENT_START_STOP,
    },
    {
      color: `${color}${CHART_AREA_GRADIENT_MID_ALPHA}`,
      stop: CHART_AREA_GRADIENT_MID_STOP,
    },
    {
      color: `${color}${CHART_AREA_GRADIENT_START_ALPHA}`,
      stop: CHART_AREA_GRADIENT_END_STOP,
    },
  ],
});
